import leadAanvraagApi from '@/api/lead-aanvraag.api';
/**
 * @type Promise
 */
export let savingPromise = undefined;

let savingInProgress = false;
let nextSaveUpdate = undefined;

export function sequentialSaveStap(
  setValueOnLeadAanvraagFunction,
  updateLeadAanvraagFunction,
  routeParams,
  update
) {
  if (savingInProgress) {
    nextSaveUpdate = update;
    return;
  }

  const leadAanvraag = setValueOnLeadAanvraagFunction(update);
  savingInProgress = savingPromise = leadAanvraagApi
    .putLeadAanvraag(routeParams, leadAanvraag)
    .then(({ data }) => {
      updateLeadAanvraagFunction(data.leadAanvraag);

      if (nextSaveUpdate) {
        const nextUpdate = { ...nextSaveUpdate };
        nextSaveUpdate = undefined;
        savingInProgress = false;
        return sequentialSaveStap(
          setValueOnLeadAanvraagFunction,
          updateLeadAanvraagFunction,
          routeParams,
          nextUpdate
        );
      }
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.resolve();
    })
    .finally(() => {
      savingInProgress = false;
    });
  return savingPromise;
}
